import "./index.scss"
import ReactDOM from "react-dom/client"
import React from "react"

import Routing from "./Routing"
import { Providers } from "./Providers"
import { BrowserRouter } from "react-router-dom"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Providers>
        <Routing />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
)
